import React from 'react';
import classNames from 'classnames';
import { createStyles } from '@jwp/ott-common/src/modules/container';

import baseStyles from './VideoDefinitionList.module.scss';

export const VideoDefinitionListIdentifier = Symbol(`VIDEO_DEFINITION_LIST`);

const VideoDefinitionList = ({
  className,
  listProperties,
  splitByComma = true,
}: {
  className?: string;
  listProperties: { label: string; value: string | React.ReactElement | null; hiddenLabel?: boolean }[];
  splitByComma?: boolean;
}) => {
  const filledProperties = listProperties.filter(({ value }) => value);
  const styles = createStyles(VideoDefinitionListIdentifier, baseStyles);

  if (filledProperties.length === 0) return null;

  return (
    <dl className={classNames([styles.definitionList, className])}>
      {filledProperties.map(({ label, value, hiddenLabel }) => (
        <div key={label}>
          <dt className={hiddenLabel ? 'hidden' : undefined}>{label}:</dt>
          {splitByComma && typeof value === 'string' ? value.split(',').map((val) => <dd key={val}>{val}</dd>) : <dd>{value}</dd>}
        </div>
      ))}
    </dl>
  );
};

export default VideoDefinitionList;
